const asyncActionType = type => ({
    pending: `${type}_PENDING`,
    success: `${type}_SUCCESS`,
    error: `${type}_ERROR`
});

export const GET_NOTIFICATION_LIST = asyncActionType('GET_NOTIFICATION_LIST');
export const DELETE_NOTIFICATION = asyncActionType('DELETE_NOTIFICATION');
export const DELETE_ALL_NOTIFICATIONS = asyncActionType('DELETE_ALL_NOTIFICATIONS');
export const MARK_NOTIFICATIONS_AS_VIEWED = asyncActionType('MARK_NOTIFICATIONS_AS_VIEWED');
export const REPORT_ERROR = asyncActionType('REPORT_ERROR');